import script from "./GreenifiedModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./GreenifiedModal.vue?vue&type=script&setup=true&lang=ts"

import "./GreenifiedModal.vue?vue&type=style&index=0&id=6ea8f284&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea8f284"]])

export default __exports__